var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgCircleArrowLeft = function SvgCircleArrowLeft(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(.5 .5)",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "square",
    strokeMiterlimit: 10
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 11
  }), /*#__PURE__*/React.createElement("path", {
    "data-color": "color-2",
    d: "M14 16l-4-4 4-4"
  }))));
};
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCI+CiAgIDxnIHRyYW5zZm9ybT0idHJhbnNsYXRlKC41IC41KSIgZmlsbD0ibm9uZSIgc3Ryb2tlPSJjdXJyZW50Q29sb3IiIHN0cm9rZS1saW5lY2FwPSJzcXVhcmUiIHN0cm9rZS1taXRlcmxpbWl0PSIxMCI+CiAgICAgIDxjaXJjbGUgY3g9IjEyIiBjeT0iMTIiIHI9IjExIiAvPgogICAgICA8cGF0aCBkYXRhLWNvbG9yPSJjb2xvci0yIiBkPSJNMTQgMTZsLTQtNCA0LTQiIC8+CiAgIDwvZz4KPC9zdmc+Cg==";
export { SvgCircleArrowLeft as ReactComponent };